import { render } from "./Passing.vue?vue&type=template&id=644992ea&scoped=true"
import script from "./Passing.vue?vue&type=script&lang=js"
export * from "./Passing.vue?vue&type=script&lang=js"

import "./Passing.vue?vue&type=style&index=0&id=644992ea&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644992ea"]])

export default __exports__